
import Handsontable from "handsontable";

export default function customDropdownRenderer(
    instance,
    td,
    row,
    col,
    prop,
    value,
    cellProperties,
) {
    var selectedId;
    var optionsList = cellProperties.selectOptions.data;
    if (
        optionsList == null ||
        typeof optionsList === "undefined" ||
        typeof optionsList.length === "undefined" ||
        !optionsList.length ||
        !value
    ) {
        Handsontable.cellTypes.text.renderer(
            instance,
            td,
            row,
            col,
            prop,
            value,
            cellProperties
        );
        return td;
    }

    // console.log("+++++++++++++++++++++++++++++++++++++++++ \n VALUESSSSSSBEFORE", value)

    var values =
        typeof value == "string"
            ? value.split("|").map(i => (typeof i == "string" ? i.trim() : i))
            : value;

    // if (prop === 'pinned_views_for_myview') {
    //     let myView = instance.getDataAtCell(row, 12)
    //     if (values[0] != myView) {
    //         let myviewIndex = values.indexOf(myView);
    //         if (myviewIndex != -1) {
    //             values.splice(myviewIndex, 1);
    //         }
    //         values.unshift(myView);
    //         instance.setDataAtCell(row, 12, values.join("|"));
    //     }
    // }


    //console.log("VALUESSSSSSSSSSSSSSSSSSSSSSSSS", values, optionsList)
    // value = [];
    // for (var index = 0; index < optionsList.length; index++) {
    //     if (values.indexOf(optionsList[index].label) > -1) {
    //         selectedId = optionsList[index].label;
    //         value.push(optionsList[index].label);
    //     }
    // }
    //console.log("VALUESSSSSSSSS BEFORE JOIN", value)
    value = values.filter(v => v !== "").join(", ");

    // console.log("VALUESSSSSSSSSAFTER JOIN", value)
    Handsontable.cellTypes.text.renderer(
        instance,
        td,
        row,
        col,
        prop,
        value,
        cellProperties
    );

    return td;
}